// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"MonthCalendar__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MonthCalendar/MonthCalendar.scss
 ** module id = 925
 ** module chunks = 1
 **/